import * as process from "./env";
import messageService from "../utils/MessageService.js";

const USERS = [
  "public",
  process.CLIENT,
  process.USER,
  process.MODER,
  process.ADMIN,
];

const getUser = (ind) => {
  return USERS[+ind];
};

export const api = {
  async get(endpoint, role, text = null) {
    try {
      const response = await fetch(`${process.BASE_URL}/${endpoint}`, {
        method: "GET",
        headers: { "x-user": getUser(+role) },
      });
     // if (!response.ok) throw new Error(text ? text : "Network error");
      return response.json();
    } catch (e) {
      if (String(e).includes("Failed to fetch")) {
        const errorText = `Потеряно соединение с интернетом${
          text ? ", " + text : ""
        }.`;
        if (text) {
          messageService.addWarningMessage(errorText, 1000);
        } else {
          messageService.addWarningMessage(errorText);
        }
      } else {
        messageService.addErrorMessage(String(e));
      }
    }
  },

  async post(endpoint, role, data, text = null) {
    try {
      const response = await fetch(`${process.BASE_URL}/${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-user": getUser(+role),
        },
        body: JSON.stringify(data),
      });
    //  if (!response.ok) throw new Error(text ? text : "Network error");
      return response.json();
    } catch (e) {
      if (String(e).includes("Failed to fetch")) {
        const errorText = `Потеряно соединение с интернетом${
          text ? ", " + text : ""
        }.`;
        if (text) {
          messageService.addWarningMessage(errorText, 3000);
        } else {
          messageService.addErrorMessage(errorText);
        }
      } else {
        messageService.addErrorMessage(String(e));
      }
    }
  },
};
